module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "BC Legal - ABC Quantum",
      "set-position": "fixed",
      "load-button": true,
      "save-button": true,
      "current": this.current,
      "create-button": true,
      "set-border": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie u-position-relative",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-200e5445!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/FatalAccidentClaims.vue
// module id = 1601
// module chunks = 0